class DesignUtils{
    static getDrawerWith(){
        return 240;
    }
}

export default DesignUtils